/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Community || (M.Template.Community = {});
M.Template.Community.Challenge || (M.Template.Community.Challenge = {});

M.Template.Community.Challenge.AboutChallengePanel = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n<h1 class="title floatL">about this challenge</h1>\n<div class="panelContent">\n  <div class="descriptionPanel">\n    '+
((__t=( challengeSummaryHtml ))==null?'':__t)+
'\n  </div>\n  <div class="prizePanel">\n    '+
((__t=( prizeHtml ))==null?'':__t)+
'\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.AnsweredAllPolls = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="headerContainer">\n  <div class="text--primary">you\'ve answered all open polls</div>\n  <p class="text--light">\n    <a href="/participate/challenges?state=submit#challenges">\n    See more polls</a> or\n    <a href="https://minteddesign.zendesk.com/hc/en-us/articles/115003615043-How-do-design-polls-work-">\n    learn how to start your own poll</a>.\n  </p>\n</div>';
}
return __p;
});

M.Template.Community.Challenge.ChallengeEntryFilePreview = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n\n<div class="challengePreviewContainer">\n  ';
 if (previewStep) { 
__p+='\n    <p class="text--tertiary">\n      Step <span class="stepNumber">1</span> of 2\n    </p>\n  ';
 } 
__p+='\n  <p class="nameLabel">\n    '+
((__t=( M.html.htmlAttributeEscape(headerText) ))==null?'':__t)+
'\n  </p>\n  <div class="challengePreviewImageContainer">\n    <div class="challengePreviewImage"></div>\n  </div>\n</div>\n<ul class="buttonGroup floatR">\n  <li>\n    <div class="progressBarContainer"></div>\n  </li>\n  <li>\n    <div class="secondaryButton"></div>\n  </li>\n  <li>\n    <div class="primaryButton"></div>\n  </li>\n</ul>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeEntryFilePreviewImage = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n<img class="challengePreviewImage" src="'+
((__t=( M.html.htmlAttributeEscape(previewImage) ))==null?'':__t)+
'"/>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeEntryFilePreviewProgress = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n<progress class="fileUploadProgressBar"\n  value="'+
((__t=( M.html.htmlAttributeEscape(fileUploadProgressPercent) ))==null?'':__t)+
'"\n  max="100">\n</progress>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeFileUpload = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n\n<ul class="floatL inline">\n  ';
 if (this.model.get('browserDoesNotSupport')) { 
__p+='\n  <li>\n    <div class="floatL">\n      <h5>Your browser is currently incompatible with making a\n        submission to this contest. Please use the latest version of\n        Firefox, Chrome or Safari to submit to this contest.</h5>\n    </div>\n  </li>\n  ';
 } else { 
__p+='\n    <li>\n      <div class="originalUploadButton"></div>\n    </li>\n    <li>\n    ';
 if (this.model.get('formErrors').designImage) { 
__p+='\n      <div class="floatL fileUploadInfo">\n        <img class="redStop" alt="red-stop"\n          src="'+
((__t=( M.img_src('/static/images/stop.png') ))==null?'':__t)+
'">\n        <p class="warning uploadError">\n          '+
((__t=( M.html.htmlEscape(this.model.get('formErrors').designImage) ))==null?'':__t)+
'\n        </p>\n      </div>\n    ';
 } else if (designImage) { 
__p+='\n      <div class="floatL fileUploadInfo">\n        <img class="greenCheck" alt="green-check"\n          src="'+
((__t=( M.img_src('/static/images/diginvites_yes_big.png') ))==null?'':__t)+
'">\n        <h5>Your file is the right size and format.</h5>\n      </div>\n    ';
 } else { 
__p+='\n      <div>\n        <p class="floatL">File must be an Illustrator file (.ai) and less than 200 MB</p>\n        ';
 if (this.model.get('formErrors').designImage) { 
__p+='\n          <p class="warning">\n            '+
((__t=( M.html.htmlEscape(this.model.get('formErrors').designImage) ))==null?'':__t)+
'\n          </p>\n        ';
 } 
__p+='\n      </div>\n    ';
 } 
__p+='\n    </li>\n  ';
 } 
__p+='\n</ul>\n\n';
/*
* If the user uploaded a file, keep track of where we uploaded the file as the
* draft_image_guid
*/
__p+='\n';
 if (designImage) { 
__p+='\n  <input type="hidden" value="'+
((__t=( M.html.htmlAttributeEscape(draftImageGuid) ))==null?'':__t)+
'"\n  name="draft_image_guid" />\n  <input type="hidden" value="'+
((__t=( M.html.htmlAttributeEscape(designImage) ))==null?'':__t)+
'"\n  name="designImage" />\n';
 } 
__p+='';
}
return __p;
});

M.Template.Community.Challenge.ChallengeHubSquarePanel = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="row top">\n  <h1>'+
((__t=( M.html.htmlAttributeEscape(title) ))==null?'':__t)+
'</h1>\n</div>\n<div class="squarePanelMainContent">\n</div>\n<div class="actionButtonContainer">\n  ';
 if (actionButtonUrl && actionButtonText && actionButtonInstrAction) { 
__p+='\n    <a href="'+
((__t=( M.html.htmlAttributeEscape(actionButtonUrl) ))==null?'':__t)+
'"\n      data-instrumented-eventspec="click"\n      data-action="'+
((__t=( M.html.htmlAttributeEscape(actionButtonInstrAction) ))==null?'':__t)+
'">\n      <button class="button buttonFlat buttonGhost buttonMedium upper\n        floatR absoluteR">\n        '+
((__t=( M.html.htmlAttributeEscape(actionButtonText) ))==null?'':__t)+
'\n      </button>\n    </a>\n  ';
 } 
__p+='\n</div>\n<div class="row bottom">\n  <a href="'+
((__t=( M.html.htmlAttributeEscape(designerProfilePageUrl)))==null?'':__t)+
'">\n    <img class="floatL userProfileImg"\n      src="'+
((__t=( M.html.htmlAttributeEscape(designerAvatarUrl)))==null?'':__t)+
'" />\n  </a>\n  <div class="infoContainer">\n    <p><a href="'+
((__t=( M.html.htmlAttributeEscape(designerProfilePageUrl)))==null?'':__t)+
'"\n         class="nameLabel">'+
((__t=(M.html.htmlAttributeEscape(designerName)))==null?'':__t)+
'</a>\n      '+
((__t=(M.html.htmlAttributeEscape(designerStatus)))==null?'':__t)+
'\n    </p>\n    <div class="location">\n      <h4>'+
((__t=(M.html.htmlAttributeEscape(designerLocation)))==null?'':__t)+
'</h4>\n    </div>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeHubSquarePanelEmpty = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="row top">\n  <h1>'+
((__t=( M.html.htmlAttributeEscape(title) ))==null?'':__t)+
'</h1>\n</div>\n<div class="middle">\n  <div class="pollOptionContainer">\n    <div class="pollOption emptyStateText">\n      <span>'+
((__t=( M.html.htmlAttributeEscape(emptyMsg) ))==null?'':__t)+
'</span>\n      <a href="'+
((__t=( M.html.htmlAttributeEscape(helpLink) ))==null?'':__t)+
'">\n        '+
((__t=( M.html.htmlAttributeEscape(helpText) ))==null?'':__t)+
'\n      </a>\n    </div>\n  </div>\n</div>\n<div class="row bottom">\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeHubTopBanner = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n\n<div class="bannerImageOverlay">\n</div>\n<div class="bannerImageText">\n  <div class="jumbotron primaryTitle floatL tc">\n    '+
((__t=( M.html.htmlEscape(challengeTitle.truncate(75)) ))==null?'':__t)+
'\n  </div>\n  <h3 class="titleDesc floatL tc">\n    '+
((__t=( M.html.htmlEscape(challengeCategory) ))==null?'':__t)+
'\n  </h3>\n  <div class="primaryButtonsContainer tc">\n    ';
 if (actionButtonDisabled) { 
__p+='\n      <a id="actionButton" class="button buttonMedium buttonFlat buttonPrimary\n        disabled arrowContainer textAndArrowPadding">\n        <span class="actionButtonContent">\n          '+
((__t=( M.html.htmlAttributeEscape(
            M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[challengeState][
              'bannerActionButtonText']) ))==null?'':__t)+
'\n          <img class="rightArrow active buttonPadding sprite"\n            src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n        </span>\n      </a>\n    ';
 } else { 
__p+='\n      <a id="actionButton" class="button buttonMedium buttonFlat buttonPrimary\n         arrowContainer textAndArrowPadding"\n        ';
 if (actionButtonUrl) { 
__p+='\n          href="'+
((__t=( M.html.htmlAttributeEscape(actionButtonUrl) ))==null?'':__t)+
'"\n        ';
 } 
__p+='\n      >\n        <span class="actionButtonContent">\n          '+
((__t=( M.html.htmlAttributeEscape(
            M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[challengeState][
              'bannerActionButtonText']) ))==null?'':__t)+
'\n          <img class="rightArrow active buttonPadding sprite"\n            src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n        </span>\n      </a>\n    ';
 } 
__p+='\n  </div>\n  <div class="bannerDateContainer floatL tc">\n    <div class="bannerDateOverlay"></div>\n    <div class="bannerDateText">\n      <div class="submissionDeadline floatL tc">\n        <div>'+
((__t=( M.html.htmlEscape(challengeDateTitle) ))==null?'':__t)+
'</div>\n        <div class="submissionDate">'+
((__t=( M.html.htmlEscape(challengeDateStr) ))==null?'':__t)+
'</div>\n      </div>\n    </div>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeSpinner = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n<div class="submitProcessingContainer">\n  <div class="processingSpinner"/>\n    <p class="calloutText">Generating preview...</p>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.ChallengeTiledPreviewImage = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

*/
__p+='\n<div\n  class="challengePreviewImage '+
((__t=( M.html.htmlAttributeEscape(tilingClass) ))==null?'':__t)+
'"\n  style="background-image:url('+
((__t=( M.html.htmlAttributeEscape(previewImage) ))==null?'':__t)+
')"\n></div>\n';
}
return __p;
});

M.Template.Community.Challenge.FeedbackComponent = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="row middle">\n    <div class="large-6 floatL designContainer">\n      <a class="designImageBox"\n          href="'+
((__t=( M.html.htmlAttributeEscape(designRatingPageUrl)))==null?'':__t)+
'">\n        <img class="designImage"\n              src="'+
((__t=( M.html.htmlAttributeEscape(designThumbnail) ))==null?'':__t)+
'" />\n      </a>\n    </div>\n    <div class="floatL feedbackRequestMsgContainer">\n      <div class="feedbackRequestMsg calloutText">\n        '+
((__t=( M.html.htmlEscape(feedbackRequestMsg.truncate(truncateLength)) ))==null?'':__t)+
'\n      </div>\n    </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Challenge.PollingComponent = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="row middle">\n  <div class="row table">\n    ';
 for (var i=0; i < 4; i++) { 
__p+='\n      <div class="large-1 floatL pollOptionsContainer designImageBox">\n        ';
 if (i < model.get('options').models.length) { 
__p+='\n          <div class="pollOptionTag text--tertiary">\n            '+
((__t=( M.html.htmlAttributeEscape(pollOptionTags[i]) ))==null?'':__t)+
'</div>\n          <a class="designImageBox"\n            href="'+
((__t=( M.html.htmlAttributeEscape(designRatingPageUrl) ))==null?'':__t)+
'">\n            <img class="designImage pollOption" src="'+
((__t=( M.html.htmlAttributeEscape(
              model.get('options').models[i].get('image')) ))==null?'':__t)+
'" />\n          </a>\n        ';
 } 
__p+='\n      </div>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
